import axios from "axios";
import Link from "next/link";
import useSWRMutation from "swr/mutation";

export const payments: Record<
  PaymentMethodType,
  {
    name: string;
    explainer: React.ReactNode;
  }
> = {
  "power-as-a-service": {
    explainer: (
      <p>
        After clicking “Pay with Flutterwave” You will be redirected to a page where you can pay securely, Click here to
        learn more about our <a href="#">privacy policy</a>
      </p>
    ),
    name: "Power As A Service",
  },
  lease: {
    explainer: (
      <>
        <p>
          Short on budget? paying in installments might be the perfect option for you, if you are looking for a way to purchase
          this product without having to pay the full price upfront. Paying in installments offers you the opportunity to spread
          out the payments over time and provides you with more flexibility in terms of financing. With pay in installments,
          you can enjoy a variety of benefits, including lower monthly payments, increased cost savings, etc.
        </p>
        <br />
        <p>
          After clicking “Pay In Installments” You will be redirected to a page where you can pay securely with Flutterwave.
          <br />
          <br />
          See our{" "}
          <Link
            href="/privacy-policy"
            style={{
              fontWeight: "bold",
              color: "var(--chateau-green)",
            }}
            target="_blank">
            data privacy policy
          </Link>{" "}
          for further information.
        </p>
      </>
    ),
    name: "Pay In Installments",
  },
  outright: {
    explainer: (
      <p>
        After selecting this option you will be redirected to a secure page where you can pay.
        <br />
        <br />
        Kindly note that Terms and Conditions apply.
        <br />
        <br />
        See our{" "}
        <Link
          href="/privacy-policy"
          style={{
            fontWeight: "bold",
            color: "var(--chateau-green)",
          }}
          target="_blank">
          data privacy policy
        </Link>{" "}
        for further information.
      </p>
    ),
    name: "Pay Outright",
  },
  splinter: {
    explainer: (
      <p>
        Pay with Splinter is an online lending payment solution that offers you digital credits that can be used to make
        purchases from merchants (in-store and online). Click <a href="#">here to learn more about Pay with Splinter</a>
        . kindly note that Terms and conditions apply.
      </p>
    ),
    name: "Pay with Splinter",
  },
  seedfi: {
    explainer: (
      <p>
        {/* Seedfi is an online lending payment solution that offers you digital credits that can be used to make
        purchases from merchants (in-store and online).
        <br />
        <br /> */}
        By selecting this option, I consent, acknowledge, and authorize you to collect my Credit Bureau data and bank
        records for the purpose of processing this financing facility.
        <br />
        <br />
        See our{" "}
        <Link
          href="/privacy-policy"
          style={{
            fontWeight: "bold",
            color: "var(--chateau-green)",
          }}
          target="_blank">
          data privacy policy
        </Link>{" "}
        for further information.
        {/* Click <a href="#">here to learn more about Pay with Specta</a>.
        kindly note that Terms and conditions apply. */}
      </p>
    ),
    name: "Pay in installments",
  },
  // seedfi: {
  //   explainer: (
  //     <p>
  //       Pay with Seedfi is an online lending payment solution that offers you digital credits that can be used to make
  //       purchases from merchants (in-store and online).
  //       <br />
  //       <br />
  //       By selecting this option, you consent, acknowledge, and authorize us to collect your Credit Bureau data, bank
  //       records, and Pay With Seedfi data for the purpose of processing this loan facility.
  //       <br />
  //       <br />
  //       See our{" "}
  //       <Link
  //         href="/privacy-policy"
  //         style={{
  //           fontWeight: "bold",
  //           color: "var(--chateau-green)",
  //         }}
  //         target="_blank">
  //         data privacy policy
  //       </Link>{" "}
  //       for further information.
  //       {/* Click <a href="#">here to learn more about Pay with Specta</a>.
  //       kindly note that Terms and conditions apply. */}
  //     </p>
  //   ),
  //   name: "Pay with Seedfi",
  // },
};

export const steps = ["Your Cart", "Shipping address", "Payment details"];

export async function deleteOrder(orderId: string) {
  await axios.delete(`orders/${orderId}/clear/`);
}

export function usePWSOTP() {
  return useSWRMutation("payments/pws_get_otp/", async (url, { arg }: { arg: Record<string, any> }) => {
    return await axios.post(url, arg);
  });
}

export function usePWSPay() {
  return useSWRMutation("orders/pay-with-specta/", async (_, { arg }: { arg: Record<string, any> }) => {
    const booking_id = arg.booking_id;
    delete arg.booking_id;
    return await axios.post(`orders/${booking_id}/pay-with-specta/`, arg);
  });
}

export function usePayBalance() {
  return useSWRMutation("payments/pay_balance/", async (url, { arg }: { arg: Record<string, any> }) => {
    return await axios.post(`${url}${arg.booking_id}`, arg);
  });
}

export function useSeedfiPay() {
  return useSWRMutation("orders/pay-with-seedfi/", async (url, { arg }: { arg: Record<string, any> }) => {
    return await axios.post(url, arg);
  });
}
